/*
 * Public API Surface of ngx-red-zoom
 */

export * from './lib/red-zoom.module';
export { RedZoomDirective } from './lib/red-zoom.directive';
